import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { DESKTOP_NAVIGATION_WIDTH } from '@resiliatech/birdsong'
import { colors } from 'Themes/Colors'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      flexGrow: 1,
      color: theme.palette.common.black,
    },
    toolBar: {
      display: 'flex',
      justifyContent: 'space-between',
      color: theme.palette.common.black,
    },
    header: {
      fontWeight: 600,
      marginLeft: '20px',
    },
    uploadButton: {
      border: '2px solid',
    },
    appBar: {
      backgroundColor: colors.resiliaWhite,
      boxShadow: '2px 4px 8px rgba(0, 50, 99, 0.07)',
      [theme.breakpoints.up('sm')]: {
        width: `calc(100% - ${DESKTOP_NAVIGATION_WIDTH}px)`,
        marginLeft: DESKTOP_NAVIGATION_WIDTH,
      },
      minHeight: '75px',
    },

    appBarLoggedOut: {
      backgroundColor: colors.resiliaWhite,
      boxShadow: '2px 4px 8px rgba(0, 50, 99, 0.07)',
      [theme.breakpoints.up('sm')]: {
        width: '100%',
      },
      minHeight: '56px',
    },

    loginContainer: {
      color: colors.black,
    },
    secureCheckoutContainer: {
      opacity: '50%',
      boxShadow: 'none',
      display: 'flex',
      alignItems: 'center',
    },
    secureCheckoutLabel: {
      fontSize: '14px',
      marginLeft: '10px',
    },
    csViewButton: {
      fontWeight: 600,
      color: colors.resiliaBlue,
    },
    billingButton: {
      background: 'none',
      color: 'inherit',
      border: 'none',
      padding: 0,
      font: 'inherit',
      outline: 'inherit',
    },
  })
)

export default useStyles
